import React, { useEffect, useState } from 'react';
import '../style/ReadingHistory.css';

const ReadingHistory = () => {
  const [history, setHistory] = useState([]);
  const [activeTab, setActiveTab] = useState('Top Ngày'); // State để theo dõi tab đang hoạt động

  useEffect(() => {
    // Lấy lịch sử đọc từ localStorage
    const readingHistory = JSON.parse(localStorage.getItem('readingHistory')) || [];
    setHistory(readingHistory);
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Cập nhật tab đang hoạt động
  };

  return (
    <div className="reading-history-container">
      <h2 className="title">TRUYỆN ĐÃ ĐỌC</h2>
      <hr style={{ margin: '20px 0', border: '1px solid #ccc' }} />
      <p className="note">Đăng nhập để lưu lịch sử đọc truyện</p>
      <div className="tabs">
        <button
          className={activeTab === 'Top Ngày' ? 'active-tab' : 'tab'}
          onClick={() => handleTabClick('Top Ngày')}
        >
          Top Ngày
        </button>
        <button
          className={activeTab === 'Top Tháng' ? 'active-tab' : 'tab'}
          onClick={() => handleTabClick('Top Tháng')}
        >
          Top Tháng
        </button>
        <button
          className={activeTab === 'Top Tổng' ? 'active-tab' : 'tab'}
          onClick={() => handleTabClick('Top Tổng')}
        >
          Top Tổng
        </button>
      </div>
      <div className="history-list">
        {history.length === 0 ? (
          <p>Không có truyện nào trong lịch sử đọc.</p>
        ) : (
          history.slice(-7).reverse().map((item, index) => ( // Hiển thị tối đa 7 truyện từ dưới lên
            <div className="history-item" key={index}>
              <p>{item}</p>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ReadingHistory;
